import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import configureRemoteAPI from "shared/utils/configureRemoteAPI";
import determineReleaseVersion from "shared/utils/determineReleaseVersion";

import App from "App";
import { store } from "app/store";
import * as serviceWorker from "serviceWorker";

import Toaster from "./Toaster";

import "modern-normalize/modern-normalize.css";

import "./css/base.css";
import "./css/table.css";

import "./css/login.css";
import "./css/barcode.css";
import "./css/old_gross_engine.css";
import "./css/barcode_login.css";

// New CSS
import "./css/accessioning.css";
import "./css/station.css";
import "./css/work_list.css";
import "./css/grossing.css";
import "./css/cutting.css";
import "./css/embedding.css";
import "./css/case_info.css";
import "./css/objects.css";

// Cases (Expected Cases, ModMed eOrders)
import "./css/cases.css";
// Users (Barcode Badges)
import "./css/users.css";
import "./css/modal.css";
// Shipping Manifest
import "./css/shipping.css";

// Sendout Requisition
import "./css/sendout_requisition.css";
// Insurance Plans
import "./css/insurance_plan.css";
// Station Document Overlay
import "./css/station_document.css";

if (
  ["dev", "stage", "uat", "next", "prod"].includes(
    process.env.REACT_APP_VPC_NAME || ""
  ) &&
  process.env.NODE_ENV === "production"
) {
  const version = determineReleaseVersion(
    process.env.REACT_APP_LIS_FRONTEND_VERSION
  );

  Sentry.init({
    dsn:
      process.env.REACT_APP_LIS_SENTRY_DSN ||
      "https://4306180280e44524b9e421dd6ff161fe@sentry.pathwatch.io/10",
    environment: process.env.REACT_APP_VPC_NAME,
    release: version,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
    ],
    tracesSampleRate: 1.0,
  });

  datadogRum.init({
    applicationId: "1810bb3f-a7ab-4b3d-8762-2fde74853bf8",
    clientToken: "pubefb52aca4e6d1580d33717ec9857e327",
    site: "datadoghq.com",
    service: "lis",
    env: process.env.REACT_APP_VPC_NAME,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });
}

configureRemoteAPI();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Toaster position="bottom-left" containerClassName="Toaster" />
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
